import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

function decodeJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch { return null; }
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    const payload = decodeJwt(token);
    if (!payload) { setLoading(false); return; }
    // Prefer explicit role from new tokens; bridge from is_admin for old tokens
    const role = payload.role || (payload.is_admin ? 'admin' : 'owner');
    setUser({ id: payload.id, username: payload.username, role });
    setLoading(false);
    // Background refresh — replaces local user with full server payload
    // (role, can_create_subusers, etc.)
    api.get('/auth/me').then(res => setUser(res.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const handle = () => setUser(null);
    window.addEventListener('auth:logout', handle);
    return () => window.removeEventListener('auth:logout', handle);
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    try { sessionStorage.removeItem('menu_path'); } catch {}
    setUser(null);
    // Tell the sign project to log out too
    window.dispatchEvent(new Event('auth:logout'));
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
